import React, { useEffect, useState } from "react";
import ForecastPageUI from "./ForecastPageUI";
import MyLoadingIcon from "../../UI/loadingIcon/MyLoadingIcon";
import { useAxiosGetRefreshing } from "../../../hooks/useAxios";
import { backend_routes } from "../../../common/links";

const ForecastsPage = function ({ kind, year, month }) {
    const [selectedSingleYear, setSingleYear] = useState(0);
    const [selectedYear, setYear] = useState(0);
    const [selectedMonth, setMonth] = useState(0);
    const [forecasts, setForecasts] = useState([]);

    const [fetchMonths, isMonthsLoading] = useAxiosGetRefreshing(
        function (response) {
            console.log(response);
        }
    );

    useEffect(() => {
        if (selectedYear !== 0 && selectedMonth !== 0)
            fetchMonths(backend_routes.FORECASTS_DAYS_AND_MONTH + selectedMonth + '.' + selectedYear);
    }, [selectedYear, selectedMonth])


    useEffect(() => {
        if (selectedYear !== 0 && selectedMonth !== 0)
            fetchMonths(backend_routes.FORECASTS_DAYS_AND_MONTH + selectedMonth + '.' + selectedYear);
    }, [selectedYear, selectedMonth])

    return (
        <>
            <ForecastPageUI kind={"day"} setMonth={setMonth} setYear={setYear}/>
            {!isMonthsLoading
            ?<></>
            :<MyLoadingIcon/>    
            }
        </>
    );
}
export default ForecastsPage;